import firebase from "firebase/app";
import "firebase/analytics";

var analytics: any = null;

const firebaseConfig = {
  apiKey: "AIzaSyDluUVlWZeezPurq1F61AzCnnPvSignQek",
  projectId: "yurifukuda-7f844",
  appId: "1:405888098718:web:f6fc6e5e8537338a21368f",
  measurementId: "G-Y0RVETSE0D"
};

const FireBaseAnalytics = {
  initialize: () => {
    firebase.initializeApp(firebaseConfig);
    analytics = firebase.analytics();
    return analytics;
  }
}

export const getAnalytics = (): any => { return analytics };

export default FireBaseAnalytics;